
import { defineComponent, ref } from "vue";
import TextareaInput from "../../components/application/inputs/TextareaInput.vue";
import { useStore } from "vuex";
import { Rating } from "../../../../domain/entities/rating";
import GradientButton from "../../components/application/buttons/GradientButton.vue";
import StarInput from "../../components/application/inputs/StarInput.vue";
import { dispatchError } from "../../utils/error_handling";
import { dispatchSuccessBox } from "../../components/mixins";

export default defineComponent({
  name: "RatingForm",
  components: { StarInput, GradientButton, TextareaInput },

  setup() {
    const store = useStore();
    const stars = ref(0);
    const message = ref("");

    const onSubmit = async (): Promise<void> => {
      try {
        await createRating();
        await clearRating();
        await dispatchSuccessBox("Avaliação enviada com sucesso");
      } catch (e) {
        console.error("[onSubmit] Error createRating ", e);
        await dispatchError(e);
      }
    };

    const createRating = async (): Promise<void> => {
      try {
        await store.dispatch(
          "content_module/rating/createRating",
          new Rating(stars.value, message.value)
        );
      } catch (e) {
        console.error("[create rating] Error dispatch ", e);
        throw e;
      }
    };

    const clearRating = () => {
      message.value = "";
      stars.value = 0;
      const starsElement: NodeListOf<HTMLInputElement> = document.querySelectorAll(
        "[data-stars]"
      );
      starsElement.forEach(star => (star.checked = false));
    };

    return {
      stars,
      message,
      onSubmit
    };
  }
});
